import { Tag } from '@cian/components';
import * as React from 'react';

import { ELayoutType } from '../../../../json_query';
import { ILayoutTypeTag } from '../../../state/tags/definitions/layout';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ILayoutTypeTagItemProps {
  tag: ILayoutTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const LayoutTypeMap = {
  [ELayoutType.IsolatedRooms]: 'Изолированные',
  [ELayoutType.UnitedRooms]: 'Смежные',
};

export const LayoutTypeTagItem = ({ tag, onDeleteClick, withNewTag }: ILayoutTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === ELayoutType.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {LayoutTypeMap[tag.value]} комнаты
    </TagComponent>
  );
};
